// src/pages/Cart.jsx
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { removeFromCart, updateQuantity, clearCart } from "../features/cart/cartSlice";
import { useNavigate } from "react-router-dom";

const Cart = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const items = useSelector((state) => state.cart.items || []);

  // ✅ حساب إجمالي السعر
  const total = items.reduce(
    (sum, item) => sum + (parseFloat(item.price) || 0) * (item.quantity || 1),
    0
  );

  // 🛒 في حالة الكارت فاضي
  if (items.length === 0) {
    return (
      <div className="container py-5 text-center">
        <h3>Your cart is empty 🛒</h3>
        <button className="btn btn-outline-custom mt-3" onClick={() => navigate("/products")}>
          Continue Shopping
        </button>
      </div>
    );
  }

  return (
    <div className="container py-5">
      <h2 className="text-center mb-4">🛍️ My Cart</h2>

      <div className="table-responsive">
        <table className="table text-center align-middle">
          <thead className="table-light">
            <tr>
              <th>Image</th>
              <th>Title</th>
              <th>Price</th>
              <th style={{ minWidth: 140 }}>Quantity</th>
              <th>Total</th>
              <th>Remove</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.id}>
                <td>
                  <img
                    src={item.image}
                    alt={item.name || item.title}
                    width="70"
                    height="70"
                    className="rounded"
                    style={{ objectFit: "cover" }}
                  />
                </td>
                <td>{item.name || item.title}</td>
                <td>${(parseFloat(item.price) || 0).toFixed(2)}</td>
                <td>
                  <div className="d-flex justify-content-center align-items-center gap-2">
                    <button
                      className="btn btn-outline-secondary btn-sm"
                      onClick={() =>
                        dispatch(
                          updateQuantity({
                            id: item.id,
                            quantity: Math.max(1, (item.quantity || 1) - 1),
                          })
                        )
                      }
                      disabled={(item.quantity || 1) <= 1}
                    >
                      -
                    </button>
                    <span>{item.quantity || 1}</span>
                    <button
                      className="btn btn-outline-secondary btn-sm"
                      onClick={() =>
                        dispatch(
                          updateQuantity({
                            id: item.id,
                            quantity: (item.quantity || 1) + 1,
                          })
                        )
                      }
                    >
                      +
                    </button>
                  </div>
                </td>
                <td>${((parseFloat(item.price) || 0) * (item.quantity || 1)).toFixed(2)}</td>
                <td>
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => dispatch(removeFromCart(item.id))}
                  >
                    <i className="fa fa-trash"></i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4 gap-3">
        <div className="d-flex gap-2">
          <button className="btn btn-outline-danger" onClick={() => dispatch(clearCart())}>
            Clear Cart
          </button>
          <button className="btn btn-outline-secondary" onClick={() => navigate("/products")}>
            Continue Shopping
          </button>
        </div>

        <div className="text-end">
          <h4 className="mb-2">Total: ${total.toFixed(2)}</h4>
          <button className="btn btn-outline-custom" onClick={() => navigate("/checkout")}>
            Proceed to Checkout
          </button>
        </div>
      </div>
    </div>
  );
};

export default Cart;
